<template>
  <ManageBox class="vehTypeManage">
    <template slot="upside">
      <el-form
        ref="form"
        :model="form"
        label-width="80px"
      >
        <el-form-item>
          <el-col :span="11">
            <el-date-picker
              size="small"
              type="datetime"
              placeholder="开始日期"
              v-model="form.beginTime"
              style="width: 100%;"
              default-time="00:00:00"
            ></el-date-picker>
          </el-col>
          <el-col
            class="line"
            :span="1"
          >-</el-col>
          <el-col :span="11">
            <el-date-picker
              size="small"
              type="datetime"
              placeholder="结束日期"
              v-model="form.endTime"
              style="width: 100%;"
              default-time="00:00:00"
            ></el-date-picker>
          </el-col>
        </el-form-item>
      </el-form>
      <SelectInput
        v-model="searchValue"
        style="margin: 20px"
      />
      <el-button
        style="margin-left: 32px"
        size="small"
        type="primary"
        @click="getRealtimeAlarmReport()"
      >查询</el-button>

      <!-- <el-button
        style="margin-left: auto"
        size="small"
        @click="exportNoxReport()"
      >导出</el-button> -->
    </template>

    <div
      class="vehTypeManage__content"
      slot="content"
    >
      <!-- 表格开始 -->
      <!-- :data="tableData.slice((currentPage-1)*pageSize,currentPage*pageSize)" -->
      <el-table
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255, 1)"
        height="100%"
        max-height="100%"
        :data="tableData"
        border
        stripe
        style="min-width: 100%"
        row-key="index"
        size="mini"
        ref="table"
      >
        <el-table-column
          fixed
          prop="index"
          label="序号"
          width="50"
          align="center"
        />
        <el-table-column
          prop="bmsNo"
          label="电池编号"
          min-width="100"
          align="center"
        />

        <el-table-column
          prop="bmsType"
          label="电池类型"
          align="center"
          min-width="180"
        />

        <el-table-column
          prop="organizationName"
          label="组织名称"
          align="center"
          min-width="180"
        />

        <el-table-column
          prop="timeBegin"
          label="报警时间"
          align="center"
          min-width="180"
        />

        <el-table-column
          prop="type"
          label="报警类型"
          align="center"
          min-width="180"
        />
        <!-- <el-table-column
          fixed="right"
          label="明细"
          width="80"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="getNoxDetail(scope.row)"
            >查看</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <!-- 表格结束 -->

      <!-- 分页开始 -->
      <el-pagination
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :page-sizes="[20, 50, 100]"
        @size-change="getRealtimeAlarmReport"
        @current-change="getRealtimeAlarmReport"
        layout="total,sizes, prev, pager, next, jumper"
        :total="total"
      />
      <!-- 分页结束 -->
    </div>
    <!-- <div
      class="vehTypeManage__footer"
      slot="footer"
    >
      <div>
        <BarChar></BarChar>
      </div>
    </div>-->
  </ManageBox>
</template>

<script>
import day from "dayjs";
import ManageBox from "@/components/ManageBox/index.vue";
import SelectInput from "@/components/SelectInput/index.vue";

export default {
  components: {
    ManageBox,
    SelectInput
  },
  data() {
    return {
      loading: false,
      form: {
        beginTime: day(day(new Date()).subtract(7, "day")).format(
          "YYYY-MM-DD 00:00:00:0"
        ),
        endTime: day(new Date()).format("YYYY-MM-DD 23:59:59:0"),
        dayBeginTime: day(day(new Date()).subtract(7, "day")).format(
          "YYYY-MM-DD 00:00:00:0"
        )
      },
      searchValue: null,
      currentPage: 1,
      pageSize: 100,
      tableData: [],
      getParams: {},
      total: 0
    };
  },
  mounted() {
    //监听表格滚动
    const dom = this.$refs.table.bodyWrapper;
    dom.addEventListener("scroll", () => {
      // console.log("scrollllllllll")
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    });
  },

  methods: {
    //获取实时报表数据
    async getRealtimeAlarmReport() {
      this.loading = true;
      let params = {
        startTime: day(this.form.beginTime || this.form.dayBeginTime).format(
          "YYYY-MM-DD HH:mm:ss:0"
        ),
        endTime: day(this.form.endTime || new Date()).format(
          "YYYY-MM-DD HH:mm:ss:999"
        ),
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        types: ""
      };
      if (this.searchValue === null || this.searchValue === "") {
        params.groupId = 0;
        params.vehicleId = 0;
      } else if (
        this.searchValue != null &&
        this.searchValue.hasOwnProperty("organizationId")
      ) {
        params.groupId = this.searchValue.organizationId;
        params.vehicleId = 0;
      } else if (
        this.searchValue != null &&
        this.searchValue.hasOwnProperty("vehicleId")
      ) {
        params.vehicleId = this.searchValue.vehicleId;
        params.groupId =
          this.searchValue.organizationId || this.searchValue.groupId;
      }
      if (this.form.beginTime > this.form.endTime) {
        this.$msg({
          showClose: true,
          message: "开始时间不能大于结束时间!",
          type: "error"
        });
        return;
      }
      this.getParams = params;
      try {
        const { data, total } = await this.$API.getRealtimeAlarmReport(params);
        this.total = total;
        this.tableData = data.map((item, index) => ({
          ...item,
          index: (this.currentPage - 1) * this.pageSize + index + 1
        }));
        if (total === 0) {
          this.$msg({
            showClose: true,
            message: "暂无数据",
            type: "success"
          });
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.error(error);
        this.$msg({
          showClose: true,
          message: error.msg,
          type: "error"
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
// ::v-deep .el-pagination {
//   padding-top: 20px;
// }
.vehTypeManage {
  &__content {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background: #fff;
    padding: 16px;
  }
  &__footer {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background: #fff;
    padding: 16px;
  }
}
span {
  color: rgb(179, 179, 179);
  margin: 10px;
}
::v-deep .el-form-item {
  margin-bottom: 2px;
}
::v-deep .el-form-item__content {
  margin-left: 0 !important;
  width: 420px;
}
::v-deep .el-col-1 {
  margin-left: 2%;
}
</style>
